import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import routes from "../router/routes.js";
function Home() {
  return (
    <div className="bg-white z-0 mt-[75px] lg:mt-[100px] md:mt-[100px]" >
      <div className='content'>
        <Suspense fallback={null}>
          <Routes>
            {routes.map((route, idx) => {
              return (
                route.element && (
                  <Route
                    key={idx}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    element={<route.element />}
                  />
                )
              )
            })}
            <Route path="/" element={<Navigate to="homepage" replace />} />
            {/* <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} /> */}
          </Routes>
        </Suspense>
      </div>
    </div>

  )
}

export default Home;
